import { z } from "@/zod";

export const storeId = z.string().length(26);
export const storeStreetNumber = z.string().min(1).max(20);
